let connected = false;
let publicKey = null;

export const checkPhantomWallet = () => {
  if (window.solana && window.solana.isPhantom) {
    return "Phantom Wallet detected. Click to connect.";
  } else {
    console.log("Phantom Wallet not found.");
    removeWalletAddress();
    return "Phantom Wallet not found. Please install Phantom Wallet.";
  }
};

export const connectWallet = async () => {
  // console.log("Attempting to connect...");
  try {
    const response = await window.solana.connect({ onlyIfTrusted: false });
    // console.log("Wallet connected:", response.publicKey.toString());
    connected = true;
    publicKey = response.publicKey.toString();
    // saveWalletAddress(publicKey);
    return { connected: true, publicKey };
  } catch (err) {
    // console.error("Connection failed:", err);
    return { connected: false, error: "Connection failed. Please try again." };
  }
};

export const disconnectWallet = () => {
  console.log("Disconnecting wallet...");
  try {
    connected = false;
    publicKey = null;
    const popup = document.querySelector('.popup'); // Ensure popup exists
    if (popup) {
      popup.style.display = 'none';
    } else {
      console.warn('Popup element not found during disconnect!');
    }
    removeWalletAddress();
    return {
      connected: false,
      message: "Wallet disconnected.",
    };
  } catch (err) {
    console.error("Disconnection failed:", err);
    return {
      connected: true,
      error: "Disconnection failed. Please reload the page.",
    };
  }
};





export const attachWalletEventListeners = (onConnect, onDisconnect) => {
  const handleConnect = () => {
    console.log(
      "Wallet connected via event listener:",
      window.solana.publicKey.toString()
    );
    connected = true;
    publicKey = window.solana.publicKey.toString();
    saveWalletAddress(publicKey);
    onConnect({ connected: true, publicKey });
  };

  const handleDisconnect = () => {
    console.log("Wallet disconnected via event listener.");
    connected = false;
    publicKey = null;
    removeWalletAddress();
    onDisconnect({ connected: false });
    setTimeout(() => window.location.reload(), 1000);
  };

  window.solana?.on("connect", handleConnect);
  window.solana?.on("disconnect", handleDisconnect);

  return () => {
    window.solana?.off("connect", handleConnect);
    window.solana?.off("disconnect", handleDisconnect);
  };
};

// Local storage management
export const saveWalletAddress = (address) => {
  localStorage.setItem("walletAddress", address);
};

export const getWalletAddress = () => {
  return localStorage.getItem("walletAddress");
};

export const removeWalletAddress = () => {
  localStorage.removeItem("walletAddress");
};
